export const GET_DASHBOARD_INFO_START = "GET_DASHBOARD_INFO_START";
export const GET_DASHBOARD_INFO_SUCCESS = "GET_DASHBOARD_INFO_SUCCESS";
export const GET_DASHBOARD_INFO_ERROR = "GET_DASHBOARD_INFO_ERROR";

export const GET_CERTIFICATES_START = "GET_CERTIFICATES_START";
export const GET_CERTIFICATES_SUCCESS = "GET_CERTIFICATES_SUCCESS";
export const GET_CERTIFICATES_ERROR = "GET_CERTIFICATES_ERROR";

// export const GET_COMMUNICATIONS_START = 'GET_COMMUNICATIONS_START';
// export const GET_COMMUNICATIONS_SUCCESS = 'GET_COMMUNICATIONS_SUCCESS';
// export const GET_COMMUNICATIONS_ERROR = 'GET_COMMUNICATIONS_ERROR';

export const SET_WIZZARD_ACTIVE_STEP = "SET_WIZZARD_ACTIVE_STEP";
export const ADD_TOAST = "ADD_TOAST";
export const CLEAR_TOASTS = "CLEAR_TOASTS";
export const REMOVE_TOAST = "REMOVE_TOAST";

export const UPDATE_RECIPIENT_START = "UPDATE_RECIPIENT_START";
export const UPDATE_RECIPIENT_SUCCESS = "UPDATE_RECIPIENT_SUCCESS";
export const UPDATE_RECIPIENT_ERROR = "UPDATE_RECIPIENT_ERROR";
